<script>
export default {
}
</script>

<template>
  <div>
    <v-flex xs12 style="margin-top: 10px;">
      <v-toolbar dark color="primary">
        <v-toolbar-title class="white--text hidden-xs-only"> Teste </v-toolbar-title>
      </v-toolbar>
    </v-flex>
    <v-flex xs12>
      <v-card style="padding: 20px;">
        <!--app-estado-grid />
        <app-estado-select :model="teste" @change="v => teste = v" />
        <pre>
          {{ teste }}
        </pre-->
      </v-card>
    </v-flex>
  </div>
</template>
